import Context = gsap.Context
import Tween = gsap.core.Tween
import Timeline = gsap.core.Timeline
import { GsapProvider } from './GsapProvider'

export type MaybeContext = Context | null | undefined
export type MaybeAnimation = Tween | Timeline | Animation | void | undefined | null
export type TransitionEvent = (ev: any, done?: any) => MaybeAnimation

export type GsapTransitionConfig = {
  enter?: TransitionEvent
  leave?: TransitionEvent
  beforeEnter?: TransitionEvent
  beforeLeave?: TransitionEvent
}
export class GsapTransition {
  static use(config: GsapTransitionConfig) {
    const { $gsap } = GsapProvider.use()

    const active = ref(false)

    // https://gsap.com/docs/v3/GSAP/gsap.context()
    let enterCtx: MaybeContext
    let leaveCtx: MaybeContext

    function onBeforeEnter(el: any) {
      // console.log(`GSAP TRANSITION: beforeEnter`)
      active.value = true
      if (config.beforeEnter) {
        config.beforeEnter!(el)
      }
    }

    function onEnter(el: any, done: any) {
      // console.log(`GSAP TRANSITION: enter`)
      if (config.enter) {
        enterCtx = $gsap.context(() => {
          config.enter!(el, () => {
            // console.log(`GSAP TRANSITION: enter.onComplete`)
            active.value = false
            if (done) {
              done()
            }
          })
        })
      } else {
        active.value = false
      }
    }

    function onBeforeLeave(el: any) {
      // console.log(`GSAP TRANSITION: beforeLeave`)
      active.value = true
      if (config.beforeLeave) {
        config.beforeLeave!(el)
      }
    }

    function onLeave(el: any, done: any) {
      // console.log(`GSAP TRANSITION: leave`)
      if (config.leave) {
        leaveCtx = $gsap.context(() => {
          config.leave!(el, () => {
            // console.log(`GSAP TRANSITION: leave.onComplete`)
            active.value = false
            if (done) {
              done()
            }
          })
        })
      } else {
        active.value = false
      }
    }

    function onEnterCancelled() {
      console.log(`GSAP TRANSITION: onEnterCancelled`)
      active.value = false
      if (enterCtx) {
        enterCtx.revert()
      }
    }

    function onLeaveCancelled() {
      console.log(`GSAP TRANSITION: onLeaveCancelled`)
      active.value = false
      if (leaveCtx) {
        leaveCtx.revert()
      }
    }

    return {
      active,
      onBeforeEnter,
      onBeforeLeave,
      onEnter,
      onLeave,
      onEnterCancelled,
      onLeaveCancelled
    }
  }
}
